import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable()
export class RoutingState {
  history = [];

  constructor(private router: Router) {}

  public loadRouting(): void {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(({ urlAfterRedirects }: NavigationEnd) => {
      this.history = [...this.history, urlAfterRedirects];
    });
  }

  public hasHistory(): boolean {
    return this.history.length > 1;
  }

  public getHistory(): string[] {
    return this.history;
  }

  public getPreviousUrl(): string {
    return this.history[this.history.length - 2] || '/index';
  }

  public goPrevious() {
    const url = this.history[this.history.length - 2];
    this.history = this.history.slice(0, this.history.length - 2);
    this.router.navigateByUrl(url);
  }
}
